<template>
  <el-drawer
    title="作者"
    :visible.sync="drawer"
    :direction="direction"
    :with-header="false"
    :before-close="handleClose"
  >
    <div class="page_view">
      <el-table
        ref="tableArr"
        v-loading="isLoading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="getRowClass"
      >
        <template v-for="item in items">
          <el-table-column
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>
        </template>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          class="operate"
          width="160"
        >
          <template scope="scope">
            <div>
              <el-button @click="onHandle(scope.row)" size="mini" type="success">選擇</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,15]"
        :page-size="paginate"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagecount"
      ></el-pagination>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: "theme-edit",
  data() {
    return {
      drawer: false,
      direction: "rtl",
      tableData: [],
       paginate:10,
      pagecount:0,
      currentPage:1,
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" }
      ]
    };
  },
  methods: {
    show() {
      this.drawer = true;
      this.getData();
    },
    getData(page=1,size=10) {
      var self = this;
      this.$http.get("/admin/author",{size:size,page:page}).then(res => {
        console.log("res:", res);
        self.tableData = res.data.data;
      });
    },
    onHandle(value)
    {
      this.$emit("selected",value);
      this.drawer = false;
    },
    handleClose() {
      this.drawer = false;
    },
     handleCurrentChange(value)
    {
      console.log("value",value);
      this.currentPage = value
        this.getData(this.currentPage,this.paginate);
    },
    handleSizeChange(size)
    {
        this.paginate = size;
        this.getData(this.currentPage,this.paginate);
    },
  }
};
</script>